import * as React from 'react';
import IconBase, { IconBaseProps } from '../components/Icons/IconBase';
const props = {};

const SvgDoctorBriefcase = (allProps: IconBaseProps) => {
  return (
    <IconBase {...allProps}>
      <svg
        width="1em"
        height="1em"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
      >
        <path
          d="M2.625 16.375C2.62563 15.4451 2.8567 14.5298 3.29755 13.711C3.73839 12.8922 4.37527 12.1955 5.15124 11.683C5.92721 11.1705 6.81808 10.8583 7.7442 10.7743C8.67033 10.6903 9.60283 10.8372 10.4583 11.2017"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.28748 4.3175C5.81988 4.8695 6.45808 5.30852 7.16396 5.60834C7.86983 5.90815 8.6289 6.06262 9.39581 6.0625C10.173 6.06312 10.942 5.90488 11.6558 5.5975"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M4.8125 6.0625C4.8125 6.97418 5.17466 7.84852 5.81932 8.49318C6.46398 9.13784 7.33832 9.5 8.25 9.5C9.16168 9.5 10.036 9.13784 10.6807 8.49318C11.3253 7.84852 11.6875 6.97418 11.6875 6.0625C11.6875 5.15082 11.3253 4.27648 10.6807 3.63182C10.036 2.98716 9.16168 2.625 8.25 2.625C7.33832 2.625 6.46398 2.98716 5.81932 3.63182C5.17466 4.27648 4.8125 5.15082 4.8125 6.0625V6.0625Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M11.375 14.875C11.375 14.3227 11.8227 13.875 12.375 13.875H20.375C20.9273 13.875 21.375 14.3227 21.375 14.875V20.375C21.375 20.9273 20.9273 21.375 20.375 21.375H12.375C11.8227 21.375 11.375 20.9273 11.375 20.375V14.875Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.3333 11.375H17.4167C17.6377 11.375 17.8496 11.4628 18.0059 11.6191C18.1622 11.7754 18.25 11.9873 18.25 12.2083V13.875H14.5V12.2083C14.5 11.9873 14.5878 11.7754 14.7441 11.6191C14.9004 11.4628 15.1123 11.375 15.3333 11.375V11.375Z"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M16.375 16.375V18.875"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.125 17.625H17.625"
          stroke="currentColor"
          strokeWidth={1.25}
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    </IconBase>
  );
};

SvgDoctorBriefcase.displayName = 'SvgDoctorBriefcase';
export default SvgDoctorBriefcase;
